import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16.0608 4.00011L8.06077 12.0001L16.0608 20.0001L15.0001 21.0608L5.93945 12.0001L15.0001 2.93945L16.0608 4.00011Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeft;
